import React, { useState, useEffect } from 'react'; 
import { useNavigate, useParams,  useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import api from '../services/axios';
import alertService from '../services/alerts';
import '../styles/EditarProspectoPage.css';  
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

function EditarProspectoPage() {

  const emptyData = {
    id_prospecto: '', // <-- agregar aquí
    nombre_completo: '',
    numero_telefonico: '',
    fecha_contacto: '',
    ultimo_contacto:'',
    tipo_red_social: '',
    curso_interes: '',
    dia: '',
    horario_preferencia: '',
    tomo_demostracion: '',
    estado_proceso: '',
    pais_origen: '',
    estado: '',
    observaciones: '',
    numero_prospectos: '',
  };

  const [formData, setFormData] = useState(emptyData);
  const [initialData, setInitialData] = useState(emptyData); 
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState('');
  const [courses, setCourses] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);  
  const [autoFillError, setAutoFillError] = useState('');
  const navigate = useNavigate();
  const { id } = useParams();  
  const isEditing = Boolean(id);
  const location = useLocation(); 
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1025);
  
    useEffect(() => {
      const handleResize = () => {
        const mobile = window.innerWidth < 1025;
        setIsMobile(mobile);
        if (!mobile) {
          setSidebarOpen(true);
        } else {
          setSidebarOpen(false);
        }
      };
      window.addEventListener('resize', handleResize);
      if (window.innerWidth >= 1025) {
        setSidebarOpen(true);
      }
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    useEffect(() => {
      if (isMobile) {
        setSidebarOpen(false);
      }
    }, [location, isMobile]);
    const toggleSidebar = () => {
      setSidebarOpen((prev) => !prev);
    };
  
    const handleCloseSidebar = () => {
      if (isMobile && sidebarOpen) {
        setSidebarOpen(false);
      }
    };
 
  const horarioOptions = [
    'Matutino',
    'Vespertino',
    'Nocturno',
    'NA',
  ];
  const redSocialOptions = [
    'Facebook',
    'Instagram',
    'Messenger',
    'TikTok',
    'Recomendados',
    'WhatsApp',
    'Página Web',
    'X',
    'NA',
  ];
  const estadoProcesoOptions = [
    'no interesado',
    'ignora mensajes',
    'informes',
    'demostracion',
    'examen ubicacion',
    'pendiente de pago',
    'inscrito'
  ];
  const tomoDemostracionOptions = ['Sí', 'No', 'NA'];
const estadoMexicoOptions = [
    'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 'Chiapas', 'Chihuahua', 'Ciudad de México', 'Coahuila', 'Colima', 'Durango', 'Estado de México', 'Guanajuato', 'Guerrero', 'Hidalgo', 'Jalisco', 'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León', 'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
];

  
  useEffect(() => {
    const fetchCursos = async () => {
      try {
        const response = await api.get('/cursos');
        setCourses(response.data);
      } catch (err) {
        console.error('Error al obtener cursos:', err);
      }
    };
    fetchCursos();
  }, []);

  
  useEffect(() => {
    if (isEditing) {
      const fetchProspecto = async () => {
        try {
          const response = await api.get(`/prospectos/${id}`);
          const p = response.data;
           
          const normalizeDate = (date) => date ? date.substring(0, 10) : '';          
          const data = {
            id_prospecto: p.id_prospecto || '',
            nombre_completo: p.nombre_completo || '',
            numero_telefonico: p.numero_telefonico || '',
            fecha_contacto: normalizeDate(p.fecha_contacto),
            ultimo_contacto: normalizeDate(p.ultimo_contacto),
            tipo_red_social: p.tipo_red_social || '',
            curso_interes: p.curso_interes || '',
            dia: p.dia || '',
            horario_preferencia: p.horario_preferencia || '',
            tomo_demostracion: p.tomo_demostracion || 'No',
            estado_proceso: p.estado_proceso || '',
            pais_origen: p.pais_origen || '',
            estado: p.estado || '',
            observaciones: p.observaciones || '',
            numero_prospectos: p.numero_prospectos || 0,
          };
          setFormData(data);
          setInitialData(data);
        } catch (err) {
          setError('Error al obtener los datos del prospecto');
        }
      };
      fetchProspecto();
    }
  }, [isEditing, id]);

  
  const handleChange = (e) => {
    const { name, value } = e.target;
     
    if (name === 'edad' && value.length > 3) return;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

 
  const hasChanges = () => {
    return JSON.stringify(formData) !== JSON.stringify(initialData);
  };

  
  const validateForm = () => {
    const errors = {};
    if (!formData.nombre_completo.trim()) { 
        errors.nombre_completo = 'El nombre completo es requerido';
    }
    
    // Solo el estado del proceso es obligatorio
    if (!formData.estado_proceso.trim()) {
        errors.estado_proceso = 'El estado de proceso es requerido';
    }
    
    // Validar estado solo si el país es México
    if (formData.pais_origen === 'México' && !formData.estado.trim()) {
        errors.estado = 'El estado es requerido para México';
    }
    
    // Validar numero_prospectos
    if (formData.numero_prospectos === '' || formData.numero_prospectos === null) {
        errors.numero_prospectos = 'El número de prospectos es requerido';
    } else if (isNaN(formData.numero_prospectos) || formData.numero_prospectos < 0) {
        errors.numero_prospectos = 'Debe ser un número mayor o igual a 0';
    }

    return errors;
};

   
  const handleRegresar = async () => {
    if (hasChanges()) {
      const confirmed = await alertService.confirm(
        'Cambios Sin Guardar',
        'Tienes cambios sin guardar. ¿Seguro que deseas regresar?',
        {
          confirmButtonText: 'Sí, Regresar',
          cancelButtonText: 'Cancelar'
        }
      );
      if (confirmed.isConfirmed) {
        navigate('/prospectos');
      }
    } else {
      navigate('/prospectos');
    }
  };

 
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    setFormErrors({});

    const confirmed = await alertService.confirm(
      isEditing ? 'Guardar Cambios' : 'Crear Prospecto',
      isEditing
        ? '¿Estás seguro de guardar los cambios?'
        : '¿Estás seguro de crear este prospecto?',
      {
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar'
      }
    );
    if (!confirmed.isConfirmed) return;

    try {
      if (isEditing) {
        console.log('📤 Enviando datos para actualizar prospecto:', formData);
        await api.put(`/prospectos/${id}`, formData);
        await alertService.success(
          'Prospecto Actualizado',
          'Los cambios han sido guardados exitosamente.'
        );
      } else {
        console.log('📤 Enviando datos para crear prospecto:', formData);
        await api.post('/prospectos', formData);
        await alertService.success(
          'Prospecto Creado',
          'El prospecto ha sido creado exitosamente.'
        );
      }
      navigate('/prospectos');
    } catch (err) {
      console.error('❌ Error completo:', err);
      console.error('❌ Error response:', err.response);
      console.error('❌ Error data:', err.response?.data);
      
      let errorMessage = 'Error al guardar los cambios';
      
      if (err.response && err.response.data && err.response.data.error) {
        errorMessage = err.response.data.error;
      } else if (err.response && err.response.status === 409) {
        errorMessage = 'Ya existe un prospecto con estos datos';
              } else if (err.response && err.response.status === 400) {
          errorMessage = 'Datos inválidos. Por favor, verifica la información';
          if (err.response.data && err.response.data.errors) {
            console.error('❌ Errores de validación:', err.response.data.errors);
            err.response.data.errors.forEach((error, index) => {
              console.error(`❌ Error ${index + 1}:`, error);
            });
          }
        }
      
      await alertService.error('Error', errorMessage);
    }
  };
  
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasChanges()) {
        const message = "Tienes cambios sin guardar. ¿Estás seguro de salir?";
        event.returnValue = message; 
        return message; 
      }
    };
  
    const handleHistoryPopState = (event) => {
      if (hasChanges()) {
        const message = "Tienes cambios sin guardar. ¿Estás seguro de salir?";
        if (window.confirm(message)) {
          
          navigate('/prospectos');
        } else {
          event.preventDefault(); 
        }
      } else {
        navigate('/prospectos'); 
      }
    };
  
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handleHistoryPopState);
  
    window.history.pushState(null, null, window.location.href); 
  
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handleHistoryPopState);
    };
  }, [hasChanges, navigate]);
  
  
  return (
    <div className="dashboard-container">
      {(!isMobile || (isMobile && sidebarOpen)) && (
        <Sidebar
          onLogoClick={() => {
            if (isMobile) setSidebarOpen(false);
          }}
          onLinkClick={handleCloseSidebar}
        />
      )}
      <div className={`main-content ${isFilterOpen ? 'panel-open' : ''}`} onClick={handleCloseSidebar}>
        <div className="dashboard-title-card">
          {isMobile && (
            <button 
              className="menu-toggle"
              onClick={toggleSidebar}
              aria-label="Abrir menú"
            >
              <i className="fas fa-bars"></i>
            </button>
          )}
          <div className="dashboard-title-section">
            <h1 className="dashboard-title">
              {isEditing ? 'Editar Prospecto' : 'Crear Prospecto'}
            </h1>
            <span className="dashboard-title-sub">
              {isEditing ? 'Modificar información del prospecto' : 'Registrar nuevo prospecto'}
            </span>
          </div>
        </div>

        {error && (
          <div className="error-message" style={{ marginBottom: '1rem' }}>
            {error}
          </div>
        )}

        <div className="futuristic-form-container">
          <div className="form-header">
            <h2 className="form-title">
              <i className="fas fa-user-edit"></i>
              Información del Prospecto
            </h2>
            <button className="back-button" onClick={handleRegresar}>
              <i className="fas fa-arrow-left"></i>
              Regresar
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="two-column-form">
              <div className="form-column">
                {!isEditing && (
                    <div className="form-group">
                        <label>ID prospecto (opcional)</label>
                        <input
                            type="number"
                            name="id_prospecto"
                            value={formData.id_prospecto || ''}
                            onChange={handleChange}
                            min="1"
                            placeholder="ID manual (opcional)"
                            className="form-input"
                        />
                    </div>
                )}
                
                <div className="form-group">
                  <label>Número de Prospectos</label>
                  <input
                    type="number"
                    name="numero_prospectos"
                    value={formData.numero_prospectos ?? ''} 
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData(prev => ({
                        ...prev,
                        numero_prospectos: value === '' ? 0 : parseInt(value, 10)
                      }));
                    }}

                    min="0"
                    placeholder="Número de prospecto"
                    className="form-input"
                  />
                  {formErrors.numero_prospectos && (
                    <span className="error-message">{formErrors.numero_prospectos}</span>
                  )}
                </div>

                <div className="form-group">
                  <label>Nombre Completo *</label>
                  <input
                    type="text"
                    name="nombre_completo"
                    value={formData.nombre_completo}
                    onChange={handleChange}
                    placeholder="Ingresa el nombre completo"
                    className={`form-input ${formErrors.nombre_completo ? 'error' : ''}`}
                  />
                  {formErrors.nombre_completo && (
                    <span className="error-message">{formErrors.nombre_completo}</span>
                  )}
                </div>

                <div className="form-group">
                  <label>Número Telefónico</label>
                  <PhoneInput
                    country={'mx'}
                    value={formData.numero_telefonico}
                    onChange={(phone) => setFormData((prev) => ({ ...prev, numero_telefonico: phone }))}
                  />
                  {formErrors.numero_telefonico && (
                    <span className="error-message">{formErrors.numero_telefonico}</span>
                  )}
                </div>

                <div className="form-group">
                  <label>Primer Contacto</label>
                  <input
                    type="date"
                    name="fecha_contacto"
                    value={formData.fecha_contacto}
                    onChange={handleChange}
                    className="form-input"
                  />
                  {formErrors.fecha_contacto && (
                    <span className="error-message">{formErrors.fecha_contacto}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>Ultimo Contacto</label>
                  <input
                    type="date"
                    name="ultimo_contacto"
                    value={formData.ultimo_contacto}
                    onChange={handleChange}
                    className="form-input"
                  />
                  {formErrors.ultimo_contacto && (
                    <span className="error-message">{formErrors.ultimo_contacto}</span>
                  )}
                </div>                
                <div className="form-group">
                  <label>Red Social</label>
                  <select
                    name="tipo_red_social"
                    value={formData.tipo_red_social}
                    onChange={handleChange}
                    className={`select-input ${formErrors.tipo_red_social ? 'error' : ''}`}
                  >
                    <option value="">Selecciona una red social</option>
                    {redSocialOptions.map((op) => (
                        <option key={op} value={op}>{op}</option>
                    ))}
                  </select>
                  {formErrors.tipo_red_social && (
                    <span className="error-message">{formErrors.tipo_red_social}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="curso_interes">Curso de Interés</label>
                  <select
                    id="curso_interes"
                    name="curso_interes"
                    className="select-input"
                    value={formData.curso_interes}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Curso</option>
                    <option value="ingles grupal">Inglés Grupal</option>
                    <option value="ingles personalizado">Inglés Personalizado</option>
                    <option value="frances grupal">Francés Grupal</option>
                  </select>
                  {formErrors.curso_interes && (
                    <span className="error-message">{formErrors.curso_interes}</span>
                  )}
                </div>

                <div className="form-group">
                  <label>Día</label>
                  <input
                    type="text"
                    name="dia"
                    value={formData.dia}
                    onChange={handleChange}
                    placeholder="Ingresa el día"
                    className={`form-input ${formErrors.dia ? 'error' : ''}`}
                  />
                  {formErrors.dia && (
                    <span className="error-message">{formErrors.dia}</span>
                  )}
                </div>
              </div>
              
              <div className="form-column">
                <div className="form-group">
                  <label>Turno</label>
                  <select
                    name="horario_preferencia"
                    value={formData.horario_preferencia}
                    onChange={handleChange}
                    className={`select-input ${formErrors.horario_preferencia ? 'error' : ''}`}
                  >
                    <option value="">Selecciona un turno</option>
                    {horarioOptions.map((op) => (
                        <option key={op} value={op}>{op}</option>
                    ))}
                  </select>
                  {formErrors.horario_preferencia && (
                    <span className="error-message">{formErrors.horario_preferencia}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>¿Tomó Demostración?</label>
                  <select
                    name="tomo_demostracion"
                    value={formData.tomo_demostracion}
                    onChange={handleChange}
                    className={`select-input ${formErrors.tomo_demostracion ? 'error' : ''}`}
                  >
                    <option value="">Selecciona una opción</option>
                    {tomoDemostracionOptions.map((op) => (
                        <option key={op} value={op}>{op}</option>
                    ))}
                  </select>
                  {formErrors.tomo_demostracion && (
                    <span className="error-message">{formErrors.tomo_demostracion}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>Estado de Proceso *</label>
                  <select
                    name="estado_proceso"
                    value={formData.estado_proceso}
                    onChange={handleChange}
                    className={`select-input ${formErrors.estado_proceso ? 'error' : ''}`}
                  >
                    <option value="">Selecciona un estado</option>
                    {estadoProcesoOptions.map((op) => (
                        <option key={op} value={op}>{op}</option>
                    ))}
                  </select>
                  {formErrors.estado_proceso && (
                    <span className="error-message">{formErrors.estado_proceso}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>País</label>
                  <input
                    type="text"
                    name="pais_origen"
                    value={formData.pais_origen}
                    onChange={handleChange}
                    maxLength="50"
                    placeholder="Ingresa el país"
                    className={`form-input ${formErrors.pais_origen ? 'error' : ''}`}
                  />
                  {formErrors.pais_origen && (
                    <span className="error-message">{formErrors.pais_origen}</span>
                  )}
                </div>
                {formData.pais_origen === 'México' && (
                  <div className="form-group">
                    <label>Estado</label>
                    <select
                      name="estado"
                      value={formData.estado}
                      onChange={handleChange}
                      className={`select-input ${formErrors.estado ? 'error' : ''}`}
                    >
                      <option value="">Selecciona un estado</option>
                      {estadoMexicoOptions.map((op) => (
                        <option key={op} value={op}>{op}</option>
                      ))}
                    </select>
                    {formErrors.estado && (
                      <span className="error-message">{formErrors.estado}</span>
                    )}
                  </div>
                )}
                <div className="form-group">
                  <label>Observaciones</label>
                  <textarea
                    name="observaciones"
                    value={formData.observaciones}
                    onChange={handleChange}
                    placeholder="Ingresa observaciones adicionales..."
                    className={`form-input ${formErrors.observaciones ? 'error' : ''}`}
                    rows="4"
                  />
                  {formErrors.observaciones && (
                    <span className="error-message">{formErrors.observaciones}</span>
                  )}
                </div>
              </div>
            </div>
            <div className="submit-button-container">
              <button 
                type="submit" 
                className="submit-button"
                disabled={!hasChanges()}
              >
                <i className="fas fa-save"></i>
                {isEditing ? 'Guardar Cambios' : 'Crear Prospecto'}
              </button>
            </div>
          </form>
        </div>
      </div>
      {isMobile && sidebarOpen && (
        <div className="overlay" onClick={handleCloseSidebar}></div>
      )}
    </div>
  );
}

export default EditarProspectoPage;
